import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { CorosiveProtectionModel } from '../../../models/dictionaries/corosive-protection.model';

declare var $: any;


@Component({
  selector: 'app-corosion-protections-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addCorosionProtectionModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="templateCorosionProtection.name" #ctrl="ngModel" required>
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="templateCorosionProtection.description">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" [disabled]="ctrl.invalid" (click)="saveNewCorosionProtection()">Save</button>
            </div>
        </div>
    </div>
</div>


<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="editedCorosionProtection.name" #ctrl2="ngModel" required>
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="editedCorosionProtection.description">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="ctrl2.invalid" (click)="editCorosionProtection()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this corosion protection?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteCorosionProtection(editedCorosionProtection)">Delete</button>
            </div>
        </div>
    </div>
</div>

<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addCorosionProtectionModal">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let corosionProtection of corosionProtectionGridData, let row_no = index">
        <td>{{corosionProtection.name}}</td>
        <td>{{corosionProtection.description}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(corosionProtection, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(corosionProtection, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class CorosionProtectionGridComponent implements OnInit {
  isComponentHidden = true;
  corosionProtectionGridData: CorosiveProtectionModel[];
  templateCorosionProtection= new CorosiveProtectionModel();
  editedCorosionProtection= new CorosiveProtectionModel();
  rowNumber: number;
  headers: string[] = ['Name', 'Description', ''];

  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deleteCorosionProtectionSubject.subscribe( (value) => {
      this.corosionProtectionGridData = this.corosionProtectionGridData.filter(x => x._id !== value);
    });
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllCorosionProtections().subscribe((response) => {
      this.corosionProtectionGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isComponentHidden = !this.isComponentHidden;
  }

  saveNewCorosionProtection() {
    this.templateCorosionProtection.id = this.corosionProtectionGridData.length + 1;
    this.mainPageService.addNewCorosionProtectionIntoDb(JSON.stringify(this.templateCorosionProtection)).subscribe((response) => {
      this.templateCorosionProtection._id = response;
      this.corosionProtectionGridData.push(this.templateCorosionProtection);
      this.templateCorosionProtection = new CorosiveProtectionModel();
    });
  }

  setChoosenElement(element, row) {
    this.editedCorosionProtection = {
      ...element,
    };
    this.rowNumber = row;
  }

  editCorosionProtection() {
    console.log(this.corosionProtectionGridData[this.rowNumber]);
    Object.assign(this.corosionProtectionGridData[this.rowNumber], this.editedCorosionProtection);
    this.mainPageService.updateCorosionProtectionInDb(JSON.stringify(this.editedCorosionProtection)).subscribe((response) => {});
  }

  deleteCorosionProtection(element) {
    this.mainPageService.removeCorosionProtection(element._id).subscribe((res) => {}, (error: any) => {});
    this.mainPageService.deleteCorosionProtectionSubject.next(element._id);
  }
}
